var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#D9E5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 7.33331C12.2533 7.33331 10.8333 8.75331 10.8333 10.5C10.8333 12.2133 12.1733 13.6 13.9199 13.66C13.9733 13.6533 14.0266 13.6533 14.0666 13.66C14.0799 13.66 14.0866 13.66 14.0999 13.66C14.1066 13.66 14.1066 13.66 14.1133 13.66C15.8199 13.6 17.1599 12.2133 17.1666 10.5C17.1666 8.75331 15.7466 7.33331 13.9999 7.33331Z",
    fill: "#3F7CDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3866 15.4334C15.5266 14.1934 12.4933 14.1934 10.62 15.4334C9.77331 16 9.30664 16.7667 9.30664 17.5867C9.30664 18.4067 9.77331 19.1667 10.6133 19.7267C11.5466 20.3534 12.7733 20.6667 14 20.6667C15.2266 20.6667 16.4533 20.3534 17.3866 19.7267C18.2266 19.16 18.6933 18.4 18.6933 17.5734C18.6866 16.7534 18.2266 15.9934 17.3866 15.4334Z",
    fill: "#3F7CDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user-avatar.9c96d4bae0319a7c7c536a5e762912f4.svg";
export { ForwardRef as ReactComponent };